import moment from 'moment-timezone';
import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { requiresShipping } from 'checkout/checkout/helpers';
import { FormError } from 'common/components/layout';
import {
  convertUTCDateTimeStringToISODate,
  dateFormat,
  timeOnlyFormat
} from 'common/helpers/dateHelper';
import { isCoolPacks } from 'common/helpers/featureFlags';
import { updateCart } from 'redux/cart/actions';
import {
  listShippingRates,
  resetShippingRatesQuery
} from 'redux/shipping/actions';

import CoolPack from './components/CoolPack';
import ShipMethod from './components/ShipMethod';
import { validateShipping } from './validators';

class Shipping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestedShipDates: this.getInitialRequestedShipDates(props.cart.data)
    };
  }

  componentDidMount() {
    const { props } = this;

    if (!requiresShipping(props.cart.data)) {
      props.onEdit('payment');
    }

    props.listShippingRates();
  }

  getInitialRequestedShipDates = (cart) => {
    const { selectedShippingOptions } = cart;
    const { requestedShipDate, shippingServiceId } = selectedShippingOptions;

    if (!requestedShipDate || !shippingServiceId) {
      return {};
    }

    return {
      [shippingServiceId]: requestedShipDate
    };
  };

  handleSubmit = (form) => {
    const { props, state } = this;
    const data = transformData(form);

    if (state.requestedShipDates[data.shippingServiceId]) {
      data.requestedShipDate = moment(
        state.requestedShipDates[data.shippingServiceId]
      ).format();
    }

    const selectedShippingOptions = { selectedShippingOptions: data };

    const successFunction = () => {
      props.onEdit('payment');
    };
    props.updateCart(selectedShippingOptions, successFunction);
  };

  handleEdit = (e) => {
    const { props, state } = this;
    e.preventDefault();
    const data = {
      selectedShippingOptions: {
        shippingServiceId: state.shippingServiceId
      }
    };
    const successFunction = () => {
      props.onEdit('payment');
    };
    props.updateCart(data, successFunction);
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('customer');
  };

  onRequestedShipDateChange = (shipMethodId, date) => {
    this.setState((state) => ({
      requestedShipDates: {
        ...state.requestedShipDates,
        [shipMethodId]: date
      }
    }));
  };

  render() {
    const { shipping, cart, settings, form, handleSubmit } = this.props;

    if (!shipping.data && !shipping.isFetching) {
      return null;
    }
    if (!shipping.query) {
      return null;
    }

    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Shipping method</h3>
        {isCoolPacks() && <CoolPack cart={cart.data} settings={settings} />}

        <div className="c7-checkout__content__radio-options-group">
          {shipping.query.map((shipId) => {
            const shipMethod = shipping.data[shipId];
            return (
              <ShipMethod
                key={shipId}
                shipMethod={shipMethod}
                settings={settings}
              />
            );
          })}
        </div>

        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to payment method
          </button>
          <a
            href="#"
            aria-label="Return to cutomer information"
            onClick={this.handleBack}
          >
            Return to customer information
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    shippingServiceId: values.shippingServiceId,
    requestedDeliveryDate:
      values.requestedDeliveryDate &&
      convertUTCDateTimeStringToISODate(
        values.requestedDeliveryDate,
        values.deliveryTime
      )
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateShipping(data);
  return errors;
};

const mapStateToProps = (state) => {
  const initialValues = {};
  if (state.cart.data && state.cart.data.selectedShippingOptions) {
    if (state.cart.data.selectedShippingOptions.requestedDeliveryDate) {
      const deliveryTime =
        state.cart.data.selectedShippingOptions.requestedDeliveryDate.substring(
          11,
          19
        );
      initialValues.deliveryTime = timeOnlyFormat(deliveryTime);
      initialValues.requestedDeliveryDate = dateFormat(
        state.cart.data.selectedShippingOptions.requestedDeliveryDate,
        state.setting
      );
    }

    if (state.cart.data.selectedShippingOptions.shippingServiceId) {
      initialValues.shippingServiceId =
        state.cart.data.selectedShippingOptions.shippingServiceId;
    } else if (state.shipping.query) {
      state.shipping.query.forEach((shipMethodId) => {
        if (
          state.shipping.data[shipMethodId].title ===
          state.cart.data.shipping?.[0]?.title
        ) {
          initialValues.shippingServiceId = shipMethodId;
        }
      });
    }
  }

  return {
    cart: state.cart,
    shipping: state.shipping,
    initialValues
  };
};

Shipping = reduxForm({
  form: 'shippingMethod',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Shipping);

export default connect(mapStateToProps, {
  listShippingRates,
  updateCart,
  resetShippingRatesQuery
})(Shipping);
